import {connect} from 'react-redux';
import * as ModalActions from '../../actions/ModalActions';
import {withRouter} from 'react-router';
import PayWarrantySuccessView from '../../components/views/mx/PayWarrantySuccessView';
import {PayWarrantySuccess, State} from '../../types/mx/reducers';
import * as PayWarrantyActions from '../../actions/PayWarrantyActions';

const mapStateToProps = (state: State): PayWarrantySuccess => ({
    amount: state.payWarranty.amount,
    cardNumber: state.payWarranty.cardNumber.slice(-4)
});

const mapDispatchToProps = (dispatch) => {
    return {
        onPressNext: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
            dispatch(PayWarrantyActions.SET_PAID_PAY_WARRANTY_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const PayWarrantySuccessContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PayWarrantySuccessView));

export default PayWarrantySuccessContainer;